export const DEFAULT_PRODUCT_CATEGORY = 'unknown';

export const PRODUCT_CATEGORIES = Object.freeze(['cosmetic', 'otc', 'unknown']);

export function normalizeProductCategory(value) {
  return PRODUCT_CATEGORIES.includes(value) ? value : DEFAULT_PRODUCT_CATEGORY;
}

export function buildAnalyzeRequestBody(text, source, productCategory = DEFAULT_PRODUCT_CATEGORY) {
  return {
    text,
    source,
    product_category: normalizeProductCategory(productCategory),
  };
}

export function hasOtcDisclaimer(report, isFull) {
  const data = isFull ? (report?.analysis_result || {}) : (report || {});
  return Boolean(data.otc_disclaimer);
}
